export const preparados= [
  {
    categoria: "preparados",
    nombre: "Agua de Florida artesanal de limpieza ",
    imagen: require("../img/botella2.png"),
    descripcion: "Se pueden elegir macerada o destilada.Cant:100ml",
    precio: "6€ - 7€",
    tema: ["protección", "ofrendas"],
    Material: "Agua destilada, hierbas y aceites esenciales"
  },
    {
    categoria: "preparados",
    nombre: "Destilado personalizable",
    imagen: require("../img/botella2.png"),
    descripcion: "¿Quieres un destilado unico? ¿Quizá uno para tu altar? ¿Ofrendar a una entidad? Cant:100ml",
    precio: "Destilada: 7€",
    tema: ["protección", "ofrendas"],
    Material: "Agua destilada, hierbas y aceites esenciales"
  },
  {
    categoria: "preparados",
    nombre: "Hidrolato de conexión espiritual ",
    imagen: require("../img/botella1.png"),
    descripcion: "Destilación en alambique de cobre. Cant:100ml",
    precio: "6€",
    tema: ["Espiritualidad"],
    Material: "Agua destilada, hierbas y aceites esenciales"
  },
  {
    categoria: "preparados",
    nombre: "Macerado de belleza artesanal",
    imagen: require("../img/botellaBelleza.png"),
    descripcion: "Magia glamuor para que te vean y sientas bella.Cant:100ml",
    precio: "5€",
    tema: ["amor"],
    Material: "Macerado de hierbas y aceites esenciales"

  },
    {
    categoria: "preparados",
    nombre: "Hidrolato Amame",
    imagen: require("../img/botellaAmame.png"),
    descripcion: "Todo el que se acerque a ti sentirá amor y ternura.Cant:100ml",
    precio: "6€",
    tema: ["amor"],
    Material: "Destilado de hierbas y aceites esenciales"
  },
    {
    categoria: "preparados",
    nombre: "Vino de paracelso",
    imagen: require("../img/vino.png"),
    descripcion: "Conecta con la 5º esencia.Cant:50ml",
    precio: "5€",
    tema: ["Espiritualidad"],
    Material: "Macerado de hierbas y aceites esenciales"
  },
     {
    categoria: "preparados",
    nombre: "Aceite personalizable ",
    imagen: require("../img/AHierbas.png"),
    descripcion: "Cuentame que necesitas y se hará realidad en forma de aciete. Cant:50ml",
    precio: "6€",
    tema: ["abundancia","amor","proteccion","salud"],
    Material: "Macerado de hierbas y semillas "
  },
      {
    categoria: "preparados",
    nombre: "💃Aceite PombaGira💃",
    imagen: require("../img/pomba.png"),
    descripcion: "Aceite para encantar, enamorar, belleza o como ofrenda a PombaGira. Cant:50ml",
    precio: "6€",
    tema: ["amor"],
    Material: "Macerado de hierbas y semillas "
  },
      {
    categoria: "preparados",
    nombre: "🌹🔥Aceite Ven a mi🌹🔥",
    imagen: require("../img/aceiteVen.png"),
    descripcion: "⚠️Cuidado con este aceite por alta toxicidad⚠️(No topico). Cant:50ml",
    precio: "8€",
    tema: ["amor"],
    Material: "Macerado de hierbas y semillas "
  },
        {
    categoria: "preparados",
    nombre: "🪲Aceite de garrapata🪲",
    imagen: require("../img/aceiteVen.png"),
    descripcion: "⚠️Cuidado con este aceite por alta toxicidad⚠️(No topico). Cant:50ml",
    precio: "8€",
    tema: ["amor"],
    Material: "Macerado de hierbas y semillas "
  },
  {
    categoria: "preparados",
    nombre: "Oleum Victoris ",
    imagen: require("../img/aceiteVen.png"),
    descripcion: "Aceite que con la fuerza del sol te lleva al éxito y la vicotria. Cant:50ml",
    precio: "7€",
    tema: ["abundancia"],
    Material: "Macerado de hierbas y semillas "
  },
    {
    categoria: "preparados",
    nombre: "⚖️Aceite de balanza⚖️",
    imagen: require("../img/justicia.png"),
    descripcion: "Para cuando se pide justicia, equilibrio, resolución de conflictos, verdad revelada. Cant:50ml",
    precio: "7€",
    tema: ["abundancia"],
    Material: "Macerado de hierbas y semillas "
  },
    {
    categoria: "preparados",
    nombre: "Aceite Abrecaminos",
    imagen: require("../img/aceiteAbrecaminos.png"),
    descripcion: "Diseñado para eliminar bloqueos y atraer nuevas oportunidades(No apto para pieles sensibles). Cant:50ml",
    precio: "7€",
    tema: ["amor"],
    Material: "Macerado de hierbas y semillas "
  },
    {
    categoria: "preparados",
    nombre: "Unguento pies Abrecaminos",
    imagen: require("../img/unAbre.png"),
    descripcion: "¿Por donde se hacen los caminos nuevos? Por los pies",
    precio: "5€",
    tema: ["abundancia"],
    Material: "Macerado de hierbas y oliva "
  },
      {
    categoria: "preparados",
    nombre: "Tumba y hace !PUM!",
    imagen: require("../img/justicia.png"),
    descripcion: "Diseñado para eliminar brujerias o entidades(No topico). Cant:50ml",
    precio: "7€",
    tema: ["amor"],
    Material: "Macerado de hierbas y semillas "
  },
 {
    categoria: "preparados",
    nombre: "Kit personalizable pequeño ",
    imagen: require("../img/kit.png"),
    descripcion: "Kit de una sola intención que tú quieras.Todas las velas mini/vela + 1 o 2 preparados",
    precio: "15€",
    tema: ["kit"],
    Material: "Kit personazable:proteccion, amor, abundancia,etc.",
  },
   {
    categoria: "preparados",
    nombre: "Kit personalizable mediano ",
    imagen: require("../img/kit.png"),
    descripcion: "Kit de la intención que quieras.Contiene: 4 cosas de tu elección(2 velas y 2 preparados, 1 vela y 3 preparados...) No entra velones ni servidor G.",
    precio: "20€",
    tema: ["kit"],
    Material: "Kit personazable:proteccion, amor, abundancia,etc.",
  },
   {
    categoria: "preparados",
    nombre: "Kit personalizable grande ",
    imagen: require("../img/kit.png"),
    descripcion: "Velon equivale a 3 velas. Contiene: 5 cosas de tu elección. No entran servidores G.",
    precio: "30€",
    tema: ["kit"],
    Material: "Kit personazable:proteccion, amor, abundancia,etc.",
  },
     {
    categoria: "preparados",
    nombre: "Muñeco o servidor ",
    imagen: require("../img/vudu.png"),
    descripcion: "Muñeco enlazado a alguien o servidor con la intencion que quieras",
    precio: "S: 15€  G: 35€",
    tema: ["kit","amor","proteccion","salud"],
    Material: "Goma Eva o crochet.",
  },
    {
    categoria: "preparados",
    nombre: "Elekes y collares de mazo",
    imagen:[
      require("../img/elegua.png"),
      require("../img/obatala.png"),
      require("../img/yemanja.png")

    ],
    descripcion: "Elekes y mazos personalizados",
    precio: "6€ - 12€",
    tema: ["ofrendas","espiritualidad"],
    Material: "Diverso",
  },
  {
    categoria: "preparados",
    nombre: "Objetos de Orichas y Santos",
    imagen:[require("../img/LlaveE.png"),require("../img/maraca.png"),], 
    descripcion: "Ninguno es igual que otro, todos son únicos.Maracas,llaves...",
    precio: "Variable",
    tema: ["ofrendas","espiritualidad"],
    Material: "Diverso"
  },
  
]
